import React, { useEffect, useState } from 'react';
import { CnLoading } from "@alife/cn-ui";
import { useDebounce } from 'ahooks';
import './index.scss';
export default (props) => {
    const [visible, setVisible] = useState(false);
    const loadingVisible = useDebounce(visible, {
        wait: 100,
    });
    useEffect(() => {
        setVisible(!!props.visible);
    }, [props.visible]);
    // console.log('loadingVisible', loadingVisible);
    if (!loadingVisible) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement(CnLoading, { className: "cn-intelli-assistant-loading", visible: loadingVisible });
};
